// import 'default-passive-events';

import App from './App'
import store from './store/index'

import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'

import { ConfigProvider } from 'antd'

// 兼容360浏览器
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs'

import 'dayjs/locale/zh-cn'
import locale from 'antd/locale/zh_CN'
import Content from './pages/A7wjwj/conponents/Content'
import PdfViewer from './components/PdfViewer'

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

// 渲染全景图
const panoramicRoot = createRoot(document.getElementById('panoramic-root')!);

// 渲染PDF查看器
const pdfViewerRoot = createRoot(document.getElementById('pdf-viewer-root')!);

if (typeof window !== 'undefined') {

  // 渲染全景图
  panoramicRoot.render(<Content />);

  // 渲染PDF查看器
  pdfViewerRoot.render(<PdfViewer />);

  root.render(
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          colorPrimary: '#ead98f'
        }
      }}
    >
      <Provider store={store}>
        <StyleProvider hashPriority='high' transformers={[legacyLogicalPropertiesTransformer]}>
          <App />
        </StyleProvider>
      </Provider>
    </ConfigProvider>


  )



}
